module.exports = __webpack_public_path__ + "static/media/ninja-kicking.b54bdb25.png";